/* eslint-disable no-param-reassign */
import Excel from "exceljs";
// @ts-expect-error: Ignoring because it wants us to update the tsconfig.json to include "resolveJsonModule", which is not worth it just for this
import filenamify from "filenamify/browser";
import { downloadFile, saveAs } from "@/utils/blob";
import dayjs from "dayjs";
import { Location } from "../config/locations";
import { SafetyValveReport } from "../types/SafetyValveReport";

interface HeaderArgs {
  worksheet: Excel.Worksheet;
  siteName: string;
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
}
const fillHeader = ({
  siteName,
  startDate,
  endDate,
  worksheet,
}: HeaderArgs) => {
  worksheet.getCell("B2").value = siteName;
  worksheet.getCell("B3").value = startDate.format("MMM D YYYY");
  worksheet.getCell("C3").value = endDate.format("MMM D YYYY");
};

interface FillTableArgs {
  worksheet: Excel.Worksheet;
  reports: Partial<SafetyValveReport>[];
}
const fillTable = ({ worksheet, reports }: FillTableArgs) => {
  const tableStart = 7;
  reports.forEach((safetyValveReport, index) => {
    const row = worksheet.getRow(tableStart + index);

    row.getCell("A").value = dayjs(safetyValveReport.tDateTested).isValid()
      ? dayjs(safetyValveReport.tDateTested).format("MMM DD YYYY")
      : null;
    row.getCell("B").value = safetyValveReport.vPSVNumber;
    row.getCell("C").value = safetyValveReport.vVVNumber;
    row.getCell("D").value = safetyValveReport.vManufacturer;
    row.getCell("E").value = safetyValveReport.vModelNumber;
    row.getCell("F").value = safetyValveReport.vSerialNumber;
    row.getCell("G").value = safetyValveReport.vValveSize;
    row.getCell("H").value = safetyValveReport.vSetPressure;
    row.getCell("I").value = safetyValveReport.vService;
    row.getCell("J").value = safetyValveReport.DiscC;
    row.getCell("K").value = safetyValveReport.DiscA;
    row.getCell("L").value = safetyValveReport.DiscR;
  });
};

interface ExportArgs {
  siteName: string;
  startDate: dayjs.Dayjs;
  location: Location;
  reports: Partial<SafetyValveReport>[];
}

export const exportValveTestHistory = async ({
  siteName,
  startDate,
  location,
  reports,
}: ExportArgs) => {
  const response = await downloadFile("/ValveTestHistoryTemplate.xlsx");
  if (!response) {
    throw new Error("Unable to download template for valve test history");
  }
  const blob = await response.blob();
  const workbook = new Excel.Workbook();
  const arrayBuffer = await blob.arrayBuffer();
  await workbook.xlsx.load(arrayBuffer);
  const worksheet = workbook.worksheets[0];
  if (!worksheet) throw new Error("Could not find a worksheet");
  fillHeader({
    worksheet,
    siteName,
    startDate,
    endDate: dayjs(),
  });
  fillTable({
    worksheet,
    reports,
  });
  const outputBuffer = await workbook.xlsx.writeBuffer();
  const output = new Blob([outputBuffer]);
  const fileName = filenamify(
    `${location} - ${siteName} - Valve test history.xlsx`
  ) as string;

  await saveAs(output, fileName);
};
